import type { RoutePath } from '@/shared/lib/ts-router';

/** Имя таблицы списка диалогов — ключ её настроек и пресетов в настройках пользователя */
export const DIALOGS_TABLE_NAME = 'dialogsListV2';

/** Имя таблицы списка раздела «Загрузка записей» — ключ вида этого списка в настройках пользователя */
export const RECORDS_TABLE_NAME = 'recordsList';

/** Адрес раздела «Загрузка записей» — по нему список диалогов узнаёт, что открыт в этом разделе */
export const RECORDS_ROUTE_PATH = '/records' satisfies RoutePath;

export const MAIN_COLUMNS = {
  id: 'id',
  externalId: 'externalId',
  createdAt: 'createdAt',
  processedAt: 'processedAt',
  duration: 'duration',
  client: 'client',
  employeeId: 'employeeId',
  hasTranscription: 'hasTranscription',
} as const;

export type MainColumnKey = keyof typeof MAIN_COLUMNS;

export const MAIN_COLUMN_KEYS = Object.keys(MAIN_COLUMNS) as MainColumnKey[];

// Видимы только перечисленные колонки, остальные основные скрыты по умолчанию
export const DEFAULT_MAIN_COLUMNS = ['createdAt', 'client', 'employeeId'];

/**
 * События диалога, отбираемые к показу в транскрипте и на шкале записи:
 * - `pause` — паузы;
 * - `interruption` — перебивания любой стороной;
 * - `interruption_client` — перебивания клиентом;
 * - `interruption_employee` — перебивания консультантом.
 *
 * Три варианта перебивания взаимоисключающие.
 */
export const DIALOG_EVENT_FILTERS = ['pause', 'interruption', 'interruption_client', 'interruption_employee'] as const;

/** Событие диалога, отбираемое к показу */
export type DialogEventFilter = (typeof DIALOG_EVENT_FILTERS)[number];

/** Отбор событий, пока пользователь свой не выставил */
export const DEFAULT_DIALOG_EVENT_FILTERS: DialogEventFilter[] = ['pause', 'interruption'];
